import Marquee from "react-fast-marquee";

export const Ribbon = () => {
  const items = ["Nurhan & Emre", "15 Kasım", "Düğün", "Çekmeköy · İstanbul", "19:00"];
  return (
    <div
      data-testid="marquee-ribbon"
      className="border-y border-line/70 bg-surface/40 py-5"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-serif text-2xl italic tracking-tight text-gold-muted md:text-4xl">
              {t}
            </span>
            <span className="text-gold/60">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
